<template>
  <div class="my-ability">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">我们的能力</div>
      </div>
      <div class="module-body">
        <div class="content-container">
          <div class="annular-container">
            <div class="annular-container-inner">
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
              <div class="arrow"></div>
            </div>
          </div>
          <div class="data-row">
            <div class="data-item">标书/设计支持</div>
            <div class="data-item">投标保证金</div>
            <div class="data-item">开标唱标</div>
            <div class="data-item">收入合同</div>
          </div>
          <div class="data-middle">
            <div class="data-circle left">
              <img class="data-circle-icon" src="@/assets/img/home/OurAbility/icon_sjts.png">
              <div class="data-circle-name">商机推送</div>
            </div>
            <div class="data-circle right">
              <img class="data-circle-icon" src="@/assets/img/home/OurAbility/icon_fpgk.png">
              <div class="data-circle-name">发票管控</div>
            </div>
          </div>
          <div class="data-row">
            <div class="data-item">项目验收</div>
            <div class="data-item">服务团队支持</div>
            <div class="data-item">助力采购</div>
            <div class="data-item">资金透明</div>
          </div>
        </div>
        <div class="primary-btn" @click="setCloudRegisterPopup(true)">一键注册体验</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data () {
    return {

    }
  },
  methods: {
    ...mapActions(['setCloudRegisterPopup']),
  }
};
</script>

<style lang="less" scoped>
.my-ability {
  padding: 64px 0;
  background-color: #fff;
  overflow: hidden;

  .content-center {
    .module-body {
      margin-top: 13px;
      .content-container {
        height: 448px;
        padding: 35px 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .annular-container {
          width: 1575px;
          height: 448px;
          margin: 0 auto;
          background-image: url('@/assets/img/home/OurAbility/background_left.png'), url('@/assets/img/home/OurAbility/background_right.png');
          background-repeat: no-repeat, no-repeat;
          background-position: left, right;
          position: absolute;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          .annular-container-inner {
            width: 1166px;
            height: 344px;
            border-radius: 200px;
            border: 46px solid #f1f6ff;
            position: relative;
            &::before {
              content: '';
              width: calc(100% + 44px);
              height: calc(100% + 44px);
              border: 2px dashed #0659E5;
              border-radius: 200px;
              position: absolute;
              left: -24px;
              top: -24px;
            }
            .arrow {
              width: 20px;
              height: 20px;
              background-image: url('@/assets/img/home/OurAbility/arrow.png');
              background-size: 100% 100%;
              position: absolute;
              &:nth-child(1) {
                left: 40px;
                top: -12px;
                transform: rotate(-32deg);
              }
              &:nth-child(2) {
                left: 286px;
                top: -33px;
              }
              &:nth-child(3) {
                left: 530px;
                top: -33px;
              }
              &:nth-child(4) {
                left: 772px;
                top: -33px;
              }
              &:nth-child(5) {
                left: 1020px;
                top: -8px;
                transform: rotate(32deg);
              }
              &:nth-child(6) {
                left: 1017px;
                top: 242px;
                transform: rotate(146deg);
              }
              &:nth-child(7) {
                left: 770px;
                top: 265px;
                transform: rotate(180deg);
              }
              &:nth-child(8) {
                left: 526px;
                top: 265px;
                transform: rotate(180deg);
              }
              &:nth-child(9) {
                left: 282px;
                top: 265px;
                transform: rotate(180deg);
              }
              &:nth-child(10) {
                left: 36px;
                top: 241px;
                transform: rotate(-148deg);
              }
            }
          }
        }
        .data-row {
          padding: 0 204px;
          display: flex;
          justify-content: space-between;
          position: relative;
          z-index: 1;
          .data-item {
            width: 140px;
            height: 80px;
            background-image: url('@/assets/img/home/OurAbility/item_bg.png');
            background-size: 100% 100%;
            text-align: center;
            line-height: 80px;
            font-family: @font-medium;
            color: #27A3F7;
          }
        }
        .data-middle {
          display: flex;
          justify-content: space-between;
          position: relative;
          z-index: 1;
          .data-circle {
            width: 180px;
            height: 180px;
            border: 20px solid;
            border-radius: 50%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &.left {
              background-color: #FF8201;
              border-color: #FFE6CC;
            }
            &.right {
              background-color: #23CFBA;
              border-color: #D3F5F1;
            }
            .data-circle-icon {
              width: 40px;
              height: 40px;
              margin-bottom: 10px;
            }
            .data-circle-name {
              font-family: @font-medium;
              font-size: 18px;
              color: #fff;
            }
          }
        }
      }

      .primary-btn {
        width: 577px;
        height: 68px;
        margin: 46px auto 0;
        border-radius: 34px;
        line-height: 68px;
      }
    }
  }
}
</style>
